import React, {
  useRef, useState, useCallback, useEffect,
} from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import './SelectInputStyles.scss';
import { useDispatch } from 'react-redux';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import Dropdown from '../../base/Dropdown/Dropdown';
import TextInput from '../TextInput/TextInput';
import { errorNotification } from '../../../modules/Notifications/notificationDecorator';
import { getResponseError } from '../../../utils/utils';
import { LOADING_DELAY } from '../../../configs';

export default function CustomSelectInputWithHelper(props) {
  const {
    inputProps = null,
    className = '',
    fieldState = {
      error: '',
      touched: false,
    },
    // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
    // nosemgrep
    controlId = `text-input-${Math.random() * 10000}`,
    renderOption = null,
    addPlaceholder = false,
    useDefaultNull = false,
    placeholder = '',
    multiple = false,
    customToggleContent = null,
    disabled = false,
    inputClassName = '',
    portalClassName = '',
    variant = '',
    filterName = 'search',
    customRenderOptions = null,
    loadAction,
    additionalFilter = {},
    optionFormatter = null,
    defaultOptions = [],
    removeSelected = () => {},
    addSelected = () => {},
    onSelect = () => {},
  } = props;
  const {
    error,
    isTouched: touched,
  } = fieldState;
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const [toggleFunction, setToggleFunction] = useState(() => () => {});
  const anchorElement = useRef(null);
  const inputRef = useRef(null);
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState('');
  const [timer, setTimer] = useState(null);
  const isError = Boolean(error);
  const [selected, setSelected] = useState([]);
  const defaultRenderOption = item => (!item.name && item.nameId ? formatMessage({ id: item.nameId }) : item.name || '');
  let renderOptionFunction = customRenderOptions || defaultRenderOption;
  if (renderOption && typeof renderOption === 'function') {
    renderOptionFunction = renderOption;
  }

  const value = inputProps && (typeof inputProps.value !== 'undefined') ? inputProps.value : multiple ? [] : null;
  const name = inputProps && (typeof inputProps.name !== 'undefined') ? inputProps.name : '';

  useEffect(() => {
    if (typeof loadAction === 'function') {
      loadOptions();
    }
  }, []);

  const onChange = item => {
    if (inputProps && inputProps.onChange) {
      let changeValue = item.value;
      if (multiple) {
        const newValue = [...value];
        const index = value.indexOf(item.value);
        if (index > -1) {
          newValue.splice(index, 1);
          removeSelected((item.value));
        } else {
          newValue.push(item.value);
          if (!selected.find(e => e.value === item.value)) {
            setSelected([...selected, item]);
          }
          addSelected(item.value);
        }
        changeValue = newValue;
      }
      inputProps.onChange({ target: { value: changeValue, name: inputProps.name } });
      onSelect(item);
    }
  };

  const loadOptions = (value = '') => {
    const defaultOptionFormatter = item => ({ value: item.id, name: item.number });
    dispatch(loadAction({ filter: { [filterName]: value, ...additionalFilter } }))
      .then(data => {
        if (!data?.data) { return; }
        setOptions((data?.data || []).map(optionFormatter || defaultOptionFormatter));
      })
      .catch(response => errorNotification('Загрузка данных', getResponseError(response)));
  };

  const onChangeSearch = event => {
    const { value } = event.target;
    setSearch(value);
    if (!loadAction) return;
    if (timer) {
      clearTimeout(timer);
    }
    setTimer(setTimeout(() => { loadOptions(value); }, LOADING_DELAY));
  };

  let inputValue = '';
  if (!multiple) {
    const inputOption = [...defaultOptions, ...options].find(i => i.value === value);
    inputValue = inputOption ? defaultRenderOption(inputOption) : '';
  } else {
    const mergedUnique = [...defaultOptions, ...selected].reduce((acc, item) => {
      if (!acc.some(el => el.value === item.value)) {
        acc.push(item);
      }
      return acc;
    }, []);
    const selectedItems = mergedUnique.filter(item => value.includes(item.value)).map(defaultRenderOption);
    inputValue = selectedItems.join(', ');
  }
  const isSelectedPlaceholder = value => {
    if ((Array.isArray(value) && !value.length) || value === null) {
      return true;
    }
    if (typeof value === 'number' || typeof value === 'string') {
      return !String(value);
    }
    return false;
  };

  const onReset = event => {
    const v = multiple ? [] : useDefaultNull ? null : '';
    inputProps.onChange({ target: { value: v, name: inputProps.name } });
    event.preventDefault();
    event.stopPropagation();
  };

  return (
    <div className={classNames('form-control-wrapper', className)}>
      <Dropdown
        usePortal
        disabled={disabled}
        setToggleFunction={a => setToggleFunction(() => a)}
      >
        <Dropdown.Toggle className="select-toggle">
          {!customToggleContent || typeof customToggleContent !== 'function'
            ? (
              <TextInput
                {...props}
                readOnly
                inputAfter={(
                  <div id={controlId} className="select-arrow-wrapper">
                    {inputValue ? <Icons customIcon onClick={onReset} width={18} height={18} icon="close" /> : null}
                    <Icons customIcon className="select-arrow" width={12} height={8} icon="arrow-down" />
                  </div>
              )}
                className={classNames('custom-select', { 'is-invalid': isError && touched }, inputClassName)}
                fieldState={fieldState}
                containerRef={anchorElement}
                inputProps={{
                  name,
                  onChange: () => {},
                  value: inputValue,
                  // onBlur: () => typeof toggleFunction === 'function' && setTimeout(() => toggleFunction(false), 100),
                  // onFocus: () => typeof toggleFunction === 'function' && toggleFunction(true),
                }}
                variant={variant}
              />
            )
            : customToggleContent(props, value, options, anchorElement)}
        </Dropdown.Toggle>
        <Dropdown.Menu
          useResizeContent={false}
          disableClickToggle={multiple}
          rightPadding={32}
          className="select-options-wrapper with-filter"
          anchorElement={anchorElement}
          classNamePortal={classNames('portal-select-options', portalClassName)}
        >
          <TextInput
            inputProps={{
              onChange: onChangeSearch,
              value: search,
              onClick: e => {
                e.stopPropagation();
                e.preventDefault();
              },
            }}
            placeholder="Поиск"
            className="select-search-input"
            inputAfter={(
              <Icons customIcon className="search" width={16} height={16} icon="search-small" />
                     )}
          />
          <div className="select-options-list">
            {addPlaceholder
              ? (
                <div
                  className={classNames('select-option', { selected: isSelectedPlaceholder(value) })}
                  onClick={() => { onChange({ value: multiple ? [] : useDefaultNull ? null : '' }); }}
                >
                  {renderOptionFunction({ name: placeholder || '' })}
                </div>
              )
              : null}
            {options.map((item, key) => {
              let isSelected = item.value === value;
              if (multiple) {
                isSelected = !!value.includes(item.value);
              }
              return (
                <div
                  key={key}
                  className={classNames('select-option', { selected: isSelected })}
                  onClick={() => { onChange(item); }}
                >
                  {renderOptionFunction(item, key, isSelected)}
                </div>
              );
            })}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
